import { tagName } from "@ember-decorators/component"
import Component from "@ember/component"
import { inject as service } from "@ember/service"
import findDocument from "cc-frontend/helpers/find-document"

@tagName("")
export default class SessionProvider extends Component.extend() {
  /**
   * Related Models
   */
  @service("ember-store")
  store

  @findDocument("sessionId", "session")
  model
}
